import { ChannelTypeEnum } from "../../types";
import EventBus from "../event-bus";
const wsConnectStatusChangeHook = new EventBus<{
  channelType: ChannelTypeEnum;
  status: boolean;
}>("wsConnectStatusChangeHook");
export default wsConnectStatusChangeHook;
